class AlsoAvailable extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      // Run when the element is added to the DOM
      this.render();
    }
  
    disconnectedCallback() {
      // Cleanup if necessary when element is removed from the DOM
    }
  
    render() {
      // Clear existing content
      this.innerHTML = '';
      const settings = {};

      // Extract settings from data attributes
      Array.from(this.attributes).forEach(attribute => {
        if (attribute.name.startsWith('data-settings-')) {
          // Convert attribute name to camelCase
          const settingName = attribute.name
            .replace('data-settings-', '')  // Remove the prefix
            .replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
          
          // Store the setting value
          settings[settingName] = attribute.value;
        }
      });
  
      const query = `{
        products(first: 50, query: "title:${settings.productTitle}") {
          edges {
            node {
              handle
              title
              onlineStoreUrl
              featuredImage {
                height
                width
                transformedSrc(maxWidth: ${settings.imageWidth})
              }
              metafield(key: "dynamic_swatch", namespace: "arkhi") {
                reference {
                  ... on MediaImage {
                    id
                    image {
                      height
                      width
                      transformedSrc(maxWidth: ${settings.imageWidth})
                    }
                  }
                }
              }
            }
          }
        }
      }`;
  
      Arkhi.GraphQL.sendRequest(query)
        .then(productJson => {
          // Filter the JSON return to ensure we're only iterating over products with the same product title
          const products = productJson.data.products.edges.filter(edge => edge.node.title.includes(settings.productTitle));
          if(products.length > 0) {
            const maxProductsToShow = settings.productLimit;
            products.slice(0, maxProductsToShow).forEach(product => {
              product = product.node;
  
              const productItem = document.createElement('div');
              productItem.classList.add('also-available__item');
              if (settings.roundedImages !== "0") {
                productItem.style.borderRadius = `${settings.roundedImages}px`;
              }
              if (settings.currentProductHandle === product.handle) {
                productItem.classList.add('also-available__item--active');
              }
  
              if(settings.swatchType === "image") {
                let imageSrc = product.featuredImage.transformedSrc;
                let imageAspectRatio = Arkhi.calculateAspectRatioAsDecimal(product.featuredImage.width, product.featuredImage.height);
                if(product.metafield && product.metafield.reference) {
                  imageSrc = product.metafield.reference.image.transformedSrc;
                  imageAspectRatio = Arkhi.calculateAspectRatioAsDecimal(product.metafield.reference.image.width, product.metafield.reference.image.height);
                }
                productItem.innerHTML = `
                  <a href="/products/${product.handle}">
                    <img class="also-available__item-image" src="${imageSrc}" alt="Picture of ${productItem.title}" width="${settings.imageWidth}" height="${settings.imageWidth / imageAspectRatio}" loading="lazy">
                  </a>
                `;
              } else {
                let colour = product.title.split(settings.titleSplit).pop().toLowerCase().trim();
                let colourHandle = colour.replaceAll(' ', '-').replaceAll('/', '-');
                let colourSwatchFallback =  colourHandle.split('-').pop();
                let colourImage = settings.fileStructure.replace('colour', `swatch-${colourHandle}`);
                let hasValidImg = false;
                let colourObject = window.theme.settings.metaobjectColors.find(item => item.colorName === product.title.split(settings.titleSplit).pop().trim());
                if(this.checkImage(colourImage)) {
                  hasValidImg = true;
                }
                if(colourObject) {
                  if(!hasValidImg && colourObject.colorImageUrl) {
                    colourImage = colourObject.colorImageUrl;
                  }
                  if(colourObject.colorHex) {
                    colourSwatchFallback = colourObject.colorHex;
                  }
                }
                
                productItem.innerHTML = `
                  <a href="/products/${product.handle}">
                    <span class="also-available__item-color-swatch" title="${product.title.split(settings.titleSplit).pop()}" style="background-color: ${colourSwatchFallback}; background-image: url(${colourImage}); width: ${settings.imageWidth}px; height: ${settings.imageWidth}px; display: block;"></span>
                  </a>
                `;
              }
  
              this.appendChild(productItem);
            })
          } else {
            let productPageParent = this.closest('.also-available__product');
            if(productPageParent) {
              productPageParent.classList.add('hidden');
            }
          }
        })
    }
  
    checkImage(url) {
      let request = new XMLHttpRequest();
      request.open("GET", url, true);
      request.send();
      request.onload = function() {
        if (request.status == 200) {
          console.log('has valid image', url);
          return true
        } else {
          console.log('img invalid', url);
          return false
        }
      }
    }
  }
  
  // Define the custom element
  customElements.define('also-available', AlsoAvailable);